import { Enums } from "@/enums";
import * as devalue from "devalue";
import { isNotNil } from "es-toolkit";
import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const ResellerRegistrationRoutes = defineRoute({
    record: {
        route: {
            path: "/reseller-registration",
            component: () => loadView(import("./ResellerRegistrationTable.vue")),
        },
        build(filter?: { status?: Enums.RegistrationStatusEnum.Values[] }) {
            if (isNotNil(filter)) {
                const encoded = btoa(devalue.stringify(filter));
                return `/reseller-registration?&filter=${encoded}`;
            }

            return "/reseller-registration";
        },
    },
    create: {
        route: {
            path: "/reseller-registration/create",
            component: () => loadView(import("./ResellerRegistrationCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/reseller-registration/:id",
            component: () => loadView(import("./ResellerRegistrationUpdate.vue")),
        },
        build(id: string) {
            return `/reseller-registration/${id}`;
        },
    },
});
